import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import BondsDeptsStaticsContainer from '../../containers/bonds-depts-statics/BondsDeptsStaticsContainer';

const BondsDeptsStaticsViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="채권&채무 관리/채권&채무 통계"
        icon="bonds_dept"
      />
      <BondsDeptsStaticsContainer />
    </div>
  );
};

export default BondsDeptsStaticsViewPage;
